import React from 'react'
import {EstadoAceptado} from './EstadoAceptado';
import {Estado} from './Estado';
import { useSelector } from 'react-redux';



const ESTADO_USUARIO = {
    1: <Estado />,
    0: <EstadoAceptado />,

};
  
function EstadoUsuario({ state }) {
    return <div>{ESTADO_USUARIO[state]}</div>;
}
  
export const HomeEstadoEnvio = () => {
    const {afiliadoEncontrado} = useSelector(state => state.preinscripto)
    return (
        <React.Fragment>
                <EstadoUsuario state={afiliadoEncontrado?.estado}></EstadoUsuario>
        </React.Fragment>
    );
                    
}

